<!--
Copyright (C) 2020 GanttProject Cloud OU
Author: Dmitry Kazakov, Dmitry Barashev

This component shows a Gantt chart.
--><template>
    <div class="h-100">
        <MxGraphChart ref="ganttChart" graphId="ganttChart" :initGraph="initGraph"/>
        <ProgressIndicator ref="progress" id="ganttchart-glasspane" type="spinner"></ProgressIndicator>
    </div>
</template>

<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import {XmlChartDto, mx} from '@/components/MxGraphChart.vue';
import MxGraphChart from "@/components/MxGraphChart.vue";
import {handleXhrError} from '@/utils/Ui';
import {ProjectGanttChart} from '@/ProjectRoutes';
import ProgressIndicator from '@/components/ProgressIndicator.vue';

@Component({
  components: {MxGraphChart, ProgressIndicator},
})
export default class GanttChart extends Vue {
  public $refs!: {
    ganttChart: MxGraphChart,
    progress: ProgressIndicator
  };

  public updateGraph(projectRefid: string) {
    if (this.$refs.ganttChart.isMxGraphSupported()) {
      this.$refs.progress.toggle(true);
      ProjectGanttChart.invoke({
        projectRefid: projectRefid
      }).done((graph: XmlChartDto) => {
        this.$refs.ganttChart.buildChart(graph);
      }).fail((jqXhr) => {
        handleXhrError(jqXhr, 'Gantt chart loading failed');
      }).always(() => {
        this.$refs.progress.toggle(false);
      });
    }
  }

  private initGraph(graph: typeof mx.mxGraph) {
    graph.getLabel = function(cell) {
      if (mx.mxUtils.isNode(cell.value)) {
        return cell.getAttribute('text', '');
      }
    };
    graph.setEnabled(false);
  }
}
</script>
